import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * One QueryClient for the app.
 *
 * `refetchIntervalInBackground` is deliberately absent — CLAUDE.md §8 bans it. Set to
 * true it keeps polling in hidden tabs, so a user with the dashboard open in a
 * forgotten tab quietly generates load all day.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Retrying a 4xx just repeats the same rejection. Only transient faults
          // are worth a second attempt, and never more than twice.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
